<template>
  <div class="bg">
    <el-carousel
      class="honeBannerBox"
      height="auto"
      :interval="4000"
      :indicator-position="swiperList.length>1?'':'none'"
      :arrow="swiperList.length>1?'hover':'never'">
      <!-- 图片用于占位： 实现banner高度自适应 -->
      <img v-if="swiperList.length" class="maskBannerImg" :src="swiperList[0].picUrl" width="100%"  >
      <el-carousel-item v-for="(item,index) in swiperList" :key="index">
        <a :href="item.link" target="_blank">
          <img class="swiper-img" :src="item.picUrl"  alt="banner">
        </a>
      </el-carousel-item>
    </el-carousel>
    <div class="LinkAbilitBox">
      <div class="LinkAbilitContent">
        <div class="newsBox" v-if="newsList.length">
          <div class="newsList">
            <router-link class="dl item" v-for="(item,index) in newsList" :key="index"  :to="{path:'/home/news/info',query:{newsId:item.id}}">
              <div class="imgBox">
                <img src="../../assets/img/home/newsicon.png" alt="">
              </div>
              <div class="textBox">
                <dt class="dt ellipsis2">{{item.title}}</dt>
                <dt class="dd">{{item.publishTime | parseTime('{y}-{m}-{d}')}}</dt>
              </div>  
            </router-link>
            <router-link class="more " to="/home/news/list" v-if="newsList.length>3">
              <img src="../../assets/img/home/moreBlue.png" alt="">
            </router-link>
          </div>
        </div>
        <div class="platformBox">
          <div class="titleBox">
            <h1>跨平台链接能力</h1>
            <p>多端支持，自定义配置管理</p>
          </div>
          <div class="platform">
            <div class="imgBox">
              <img src="../../assets/img/home/platform0.png" alt="">
            </div>
            <div class="imgBox">
              <img src="../../assets/img/home/platform1.png" alt="">
            </div>
            <div class="imgBox">
              <img src="../../assets/img/home/platform2.png" alt="">
            </div>
            <div class="imgBox">
              <img src="../../assets/img/home/platform3.png" alt="">
            </div>

          </div>
        </div>
      </div>     
    </div>
    <div class="appWakeUpBox">
      <div class="appWakeUp">
        <div class="titleBox">
            <h1>应用唤起 下载服务</h1>
            <p>华为、OPPO、vivo、小米、苹果手机已支持统一链接的应用唤起<br>应用商店的无缝下载服务，其他品牌支持自定义跳转</p>
          </div>
      </div>
    </div>
    <div class="dataAttributionBox">
      <div class="dataAttribution">
        <div class="titleBox">
            <h1>数据统计服务</h1>
            <p>提供链接访问等数据的统计服务帮助您了解链接的使用情况</p>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from "swiper"
import 'swiper/dist/css/swiper.css'
import LoginVue from '../account/Login.vue';

export default {
  created() {
    this.queryBannerList();
    this.queryNewsList();
  },
  mounted () { 
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    // this.initSwiper();//初始化文档滑动
    // window.addEventListener('scroll', this.handleScroll)
  },
  data() {
    return {
      homeData: [],
      swiperList: [], //banner
      newsList: [], //资讯
      documentBtnHover: false,
      detailBtnHover: false,
      hover:false,
      partnersList:[],

    };
  },
  methods: {
    handleScroll() {
      // 处理滚动事件的逻辑
      // var scrollTop = window.pageY0ffset ||document.documentElement.scrollTop||document.body.scrollTop;
      // console.log(scrollTop);
      // console.log($('.appWakeUpBox').offset().top,"5555");
      // if(scrollTop>$('.platformBox').offset().top){
      //     $('.platformBox .titleBox').addClass('slide-in-up ')
      // }
    },
    //获取banner
    queryBannerList() {
      this.$apis.homeSever.queryBannerList({
        type:1,
      }).then(res => {
        if (res.code == 0) {
          this.swiperList = res.data;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    //初始化滑动
    // initSwiper() {
    //   this.swiper = new Swiper('.swiper-container', {
    //       loop:true,//循环轮播
    //       autoplay: 2000,//可选选项，自动滑动
    //       slidesPerView: 5,
    //       loopedSlides :15,
    //       pagination: '.swiper-pagination',
    //       prevButton: '.swiper-button-prev',
    //       nextButton: '.swiper-button-next',
    //   });
    //   // $('.swiper-container').on('mouseover', ()=> {
    //   //   this.swiper.stopAutoplay();
    //   // });
    //   // $('.swiper-container').on('mouseleave', ()=> {
    //   //   this.swiper.startAutoplay();
    //   // });
    // },
    //获取资讯
    queryNewsList() {
      this.$apis.newsSever.queryNewsList({
        page:1,
        perPage:4,
      }).then(res => {
        if (res.code == 0&&res['data']['data']) {
          this.newsList = res.data.data;
        }
      });
    },
    openModal() {
      this.$msgBox
        .accountWhiteMessageBox({
          title: "",
          content: ""
        })
        .then(async data => {})
        .catch(val => {});  
    },
    lookMore(){
      let routeUrl = this.$router.resolve({
        path:'/documents/'  ,
      })
      
      window.open(routeUrl.href, '_blank')
    },
    getInfo(index){
      this.homeData[index].hover = true;
      this.homeData=JSON.parse(JSON.stringify(this.homeData))//深拷贝监听数组变化
    },
    drawOut(index){
      this.homeData[index].hover = false;
      this.homeData=JSON.parse(JSON.stringify(this.homeData))
    },
  },
  // beforeDestroy() {
  //   window.removeEventListener('scroll', this.handleScroll)
  // }
};
</script>

<style  lang="scss" scoped>
/deep/ .el-carousel__indicator.is-active button {
  background-color: #2E84FC;
}

/deep/ .el-carousel__indicator button {
  background-color:(255,255,255,.75);
}
/deep/ .el-carousel__indicators { // 指示灯位置
  transform: translateX(-50%);
  bottom: 12%;
  left: 50%;

}
@keyframes slideInUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.slide-in-up {
  animation: slideInUp 0.5s ease-in;
}

.bg {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .honeBannerBox{
    overflow: hidden;
    height: 638px;
    width:100%;
    .maskBannerImg{
      vertical-align:top;
      width: 100%;
      height: 638px;
    }
    /deep/.el-carousel__container{
       height: 638px;
    }
    .swiper-img{
      width: 1920px;
      // height: 100%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  
  .titleBox{
    h1{   
      font-size: 36px;
      color: #333333;
      font-weight: bold;
      margin-bottom: 15px;
    }
    p{
      color: #666666;       
      font-size: 18px;
      line-height: 32px;
    }
  }
  .LinkAbilitBox{
    width: 100%;
    height: 662px;
    background: url(../../assets/img/home/platformBg.png) top no-repeat ;
    position: relative;
    .newsBox{
      width: 1200px;
      height: 132px;
      position: absolute;
      top:-80px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9;
      .newsList{
        position: relative;
        display: flex;
        .dl{
          width: 275px;
          height: 120px;
          background: #FFFFFF;
          border-radius: 12px 12px 12px 12px;
          opacity: 1;
          cursor: pointer;
          margin: 0 5px;
          display: flex;
          padding: 34px 0 0 25px;
          .imgBox{
            margin-right: 9px;
            img{
              width: 46px;
              height: 50px;
            }
          }
          .dt{
            // min-height: 60px;
            font-size: 16px;
            color: #282828;
            line-height: 30px;
          }
          .dd{
            font-size: 14px;
            color: #999;
            margin-top: 8px;
          }
          &:hover{
            .dt,.dd{
              color: $--color-primary !important;
            }
          }
        }
        .more{
          width:20px;
          height: 100%;
          display: flex;
          align-items: center;
          position: absolute;
          background: #FFFFFF;
          border-radius: 4px;
          right: 20px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 30px;
          color: #8F8F9A;
          cursor: pointer;
        }
      }
      @media screen and (max-width: 767px) {
        .newsList {
          display: block;
        }
      }
    }
    .platformBox{
      width: 1200px;
      padding-top: 132px;
      margin: 0 auto;
      .platform{
        margin-top: 60px;
        display: flex;
        justify-content: space-around;
         .imgBox:hover{
        transform: translateY(-20px);
        }
      }
     
    }
  }
  .appWakeUpBox{
    width: 100%;
    height: 800px;
    background: url(../../assets/img/home/appWakeUpBg.jpg) top no-repeat;
    .appWakeUp{
      padding-top:80px ;

    }
  }
  .dataAttributionBox{
    width: 100%;
    height: 800px;
    background: url(../../assets/img/home/dataAttributionBj.jpg) top no-repeat;
    .dataAttribution{
      padding-top:80px ;

    }
  }
 
 

 
}
</style>
